<template>
  <div class="uk-container">
    <transition name="fade" mode="out-in">
      <div v-if="section === 'cancel'" class="uk-card uk-card-default uk-width-large uk-margin-auto">
        <div class="uk-card-header uk-text-center">
          <h3 class="uk-card-title">Cancel Appointment</h3>
        </div>

        <div class="uk-card-body">
          <ValidationObserver ref="observer" tag="div" class="uk-form-stacked">
            <div class="uk-margin">
              <ValidationProvider v-slot="{ errors }" rules="required">
                <label class="uk-form-label" for="reason" :class="{ 'uk-text-danger': errors.length }">Cancellation Reason</label>
                <div class="uk-form-controls">
                  <textarea id="reason" v-model="reason" class="uk-textarea" :class="{ 'uk-form-danger': errors.length }" rows="3" name="reason" />
                </div>
                <div v-if="errors.length" class="form-error">{{ errors[0] }}</div>
              </ValidationProvider>
            </div>
          </ValidationObserver>
        </div>

        <div class="uk-card-footer uk-text-center">
          <button class="uk-button uk-button-danger" @click="confirm()">Confirm Appointment Cancellation</button>
        </div>
      </div>

      <div v-if="section === 'refund'">
        <status :appointment="appointment" />
        <refund :amount="(appointment.payment.amount/100).toFixed(2)" />
      </div>
    </transition>

    <div id="modal-refund" uk-modal="bg-close: false; esc-close: false;">
      <div class="uk-modal-dialog uk-modal-body uk-text-center">
        <p>Would you like to attach a refund request to this cancellation?</p>
        <p>
          <button class="uk-button uk-button-danger uk-margin-small-right" type="button" @click="refundAction(false)">No</button>
          <button class="uk-button uk-button-primary" type="button" @click="refundAction(true)">Yes</button>
        </p>
      </div>
    </div>

    <div id="modal-cancel" uk-modal="esc-close: false; bg-close: false;">
      <div class="uk-modal-dialog">
        <div class="uk-modal-body uk-text-center">Appointment was cancelled successfully!</div>
        <div class="uk-modal-footer uk-text-center">
          <div class="uk-button uk-button-primary" @click="close()">View Appointment</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import Status from '@/components/appointment/Status.vue'
import Refund from '@/components/Refund.vue'

export default {
  name: 'ComponentAppointmentCancel',

  components: {
    ValidationProvider,
    ValidationObserver,
    Status,
    Refund
  },

  data() {
    return {
      section: 'cancel',
      reason: null,
      refund: null,
      modal: {
        refund: null,
        cancel: null
      }
    }
  },

  computed: {
    appointment() {
      const { id } = this.$route.params
      const source = this.$store.getters['appointments/find'](id)
      const appointment = id ? ({ ...source }) : null

      if (appointment) {
        const { dentist } = appointment.info
        appointment.id = source.id
        appointment.dentist = {
          bit: appointment.dentist.data[dentist].bit,
          date: appointment.dentist.data[dentist].date,
          id: dentist
        }
      }

      return appointment
    }
  },

  created() {
    this.$bus.$on('refund', (data) => {
      this.refund = data
      this.cancel()
    })
  },

  mounted() {
    this.modal.refund = this.$uikit.modal('#modal-refund')
    this.modal.cancel = this.$uikit.modal('#modal-cancel')
  },

  beforeDestroy() {
    this.$bus.$off('refund')
  },

  methods: {
    async confirm() {
      const isValid = await this.$refs.observer.validate()

      if (isValid) {
        this.modal.refund.show()
      }
    },

    refundAction(required) {
      this.modal.refund.hide()

      if (required) {
        this.section = 'refund'
      } else {
        this.cancel()
      }
    },

    async cancel() {
      const loader = this.$loader.show('Cancelling Appointment')
      const cancelAppointment = this.$firebaseFunctions.httpsCallable('cancelAppointment')

      const data = {
        id: this.appointment.id,
        reason: this.reason
      }

      if (this.refund && this.refund.value && this.refund.reason) {
        data.refund = this.refund
      } else {
        data.refund = false
      }

      try {
        await cancelAppointment(data)
        await loader.hide()
        this.modal.cancel.show()
      } catch (error) {
        loader.hide(true)
        this.$uikit.notification('Something went wrong!', { status: 'danger' })
      }
    },

    close() {
      this.modal.cancel.hide()
      this.$router.push({ name: 'appointment-single', params: { id: this.appointment.id } })
    }
  }
}
</script>
